module.exports = __webpack_public_path__ + "static/media/fa-share.b842a007.svg";